import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MAX_WIDTH_CONTAINER_NotImprotant } from '../../config/cacheKey';
import { getNextInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { IRouteType } from '../../redux/handleBackBtn/IRouteType';
import { getpervStateTab } from '../../redux/loansTab/loansTabSlice';
import { RootState } from '../../redux/store';
import './appBar.css';
import useWindowWidth from '../../hooks/useWindowWidth';


const CustomizedAppBar = () => {
    const title = useSelector((state: RootState) => state.headerTitleSlice.header);
    let color = useSelector((state: RootState) => state.headerTitleSlice.color);
    const display = useSelector((state: RootState) => state.headerTitleSlice.display);
    let parentRoute = useSelector((state: RootState) => state.headerTitleSlice.parentRoute);
    const back = useSelector((state: RootState) => state.prevAndNextState.prevState);
    let routeType = useSelector((state: RootState) => state.prevAndNextState.routeType) as IRouteType;
    let innerBack = useSelector((state: RootState) => state.prevAndNextState.prevInnerState);
    const dispatch = useDispatch();
    const width = useWindowWidth();
    useEffect(() => {
        if (color?.includes('linear-gradient')) {
            color = '#fff'
        }
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        metaThemeColor!.setAttribute('content', color);
    }, [color])


    const handlePrev = (type?: any, innerBack_?: any, parentRoute_?: any) => {
        routeType = type ?? routeType;
        innerBack = innerBack_ ?? innerBack;
        parentRoute = parentRoute_ ?? parentRoute;
        if (routeType === 'parent') {
            dispatch(getpervStateTab({ prevState: 'loans12' }))
        }
        else if (routeType === 'child') {
            if (innerBack.includes('forms')) {
                dispatch(getNextInnerState({ nextInnerState: `formLists ${Math.random()} ` }));
            }
            else if (parentRoute != null && (parentRoute.includes('loanDetail') || parentRoute.includes('installmentCheque'))) {
                dispatch(getNextInnerState({ nextInnerState: parentRoute }));
            } else {
                if (innerBack.includes('storeFromLoanTemplate')) {
                    dispatch(getpervStateTab({ prevState: 'loans' }))
                } else {
                    dispatch(getNextInnerState({ nextInnerState: innerBack }));
                }
            }
        }
        else if (routeType === 'infoDetail') {
            dispatch(getpervStateTab({ prevState: 'loanDetail' }));
        }
        else if (routeType === "wallet") {
            if (parentRoute != null) {
                dispatch(getpervStateTab({ prevState: parentRoute }))
            }
        } else if (routeType === "loanDetail") {
            if (parentRoute != null) {
                dispatch(getpervStateTab({ prevState: parentRoute }))
            }
        } else if (routeType === "loans") {
            if (parentRoute != null) {
                dispatch(getpervStateTab({ prevState: parentRoute }))
            }
        }
    }
    ///handleback mobile
    const pushStateToHistory = useCallback(() => {
        if (window.history.state === null || window.history.state.routeType !== routeType) {
            window.history.pushState({ routeType, innerBack }, '', window.location.href);
        }
    }, [routeType, innerBack]);

    const handlePopState = (event: any) => {
        event.preventDefault();

        if (window.history.state === null || (window.history.state.routeType === "" && window.history.state.innerBack === "")) {
            pushStateToHistory();
        } else {
            handlePrev(routeType, innerBack, parentRoute);
        }
    };

    useEffect(() => {
        pushStateToHistory();

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [pushStateToHistory]);
    ///handleback mobile

    return (
        <>
            <Box sx={{ pb: '63px', display: `${display == 'none' ? 'none' : 'block'}` }} >
                <AppBar
                    style={{
                        maxWidth: MAX_WIDTH_CONTAINER_NotImprotant,
                        // width: width > +MAX_WIDTH_CONTAINER_NotImprotant ? `calc(${MAX_WIDTH_CONTAINER_NotImprotant} - 40px)` : width - 40,
                        borderBottom: color === "var(--header-color)" ? "1px solid var(--header-border-color)" : "",
                        backgroundColor: color,

                    }}
                    className="appBarBackground appbarMedia containerMedia"
                    elevation={3}

                >
                    <Toolbar sx={{ alignItems: "center", height: "100%", display: "flex" }}>
                        {parentRoute != null ? color !== 'transparent' && <IconButton
                            edge="start"
                            color="inherit"
                            className={`appBarBackBtn`}
                            sx={{
                                color: "var(--primary-text-color)",
                                width: "fit-content",
                                marginLeft: "10px",
                            }}
                            onClick={() => handlePrev(null, null, null)}
                        >
                            <ArrowForwardOutlinedIcon />
                        </IconButton> : <></>}
                        <div className="appBarTitle">
                            <span className={`font-bold text-sm 
                            text-[var(--primary-text-color)]
                          
                            `}
                            >{title}</span>
                        </div>

                    </Toolbar>
                </AppBar>
            </Box>
        </>
    );
};

export default CustomizedAppBar;





